/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OperationIdFilters {
  /**
  * Matches if any string in this list is a substring of `operationId`.
  */
  'contains'?: Array<string>;
  /**
  * Matches if no string in this list is a substring of `operationId`.
  */
  'notContains'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "contains",
      "baseName": "contains",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "notContains",
      "baseName": "notContains",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return OperationIdFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

